import Vue from 'vue'
import VueHorizontal from 'vue-horizontal';
import App from './App'
import router from './router'
import { store } from './store.js'
import moment from 'moment'
import momentTimeZone from "moment-timezone"
const fb = require('./firebaseConfig.js')
const globals = require('./globals.js')
import './assets/scss/app.scss'

Vue.use(VueHorizontal);

Vue.config.productionTip = false

Vue.prototype.$InvitationChangeStatus = {
  userInvited: 0,
  eventNameChanged: 1,
  eventDateChanged: 2,
  eventTimeChanged: 3,
  eventLocationChanged: 4,
  inviteesAdded: 5,
  inviteesRemoved: 6,
  inviteesAttendanceChanged: 7,
  eventMediaItemsAdded: 8,
  eventMediaItemsRemoved: 9,
  eventMessagesAdded: 10
};

Vue.prototype.$MediaItemType = {
  unknown: 0,
  photo: 1,
  video: 2
};

Vue.prototype.$DateTimeStatus = {
  unknown: 0,
  upcoming: 1,   // now < event date
  now: 2,        // now < event date + event duration (4 hours)
  recent: 3,     // now < event date + visibility period (24 hours)
  past: 4        // now >= event date + visibility period
}

Vue.mixin({
  methods: {
    isEventCanceled(event) {
      return event.canceledDateTime != null;
    },
    isEventUpcoming(event) {
      return this.eventDateTimeStatus(event) == this.$DateTimeStatus.upcoming;
    },
    isEventNow(event) {
      return this.eventDateTimeStatus(event) == this.$DateTimeStatus.now;
    },
    isEventRecent(event) {
      return this.eventDateTimeStatus(event) == this.$DateTimeStatus.recent;
    },
    isEventPast(event) {
      return this.eventDateTimeStatus(event) == this.$DateTimeStatus.past;
    },
    isEventUpcomingOrNow(event) {
      return this.isEventUpcoming(event) || this.isEventNow(event);
    },
    isEventNowOrRecent(event) {
      return this.isEventNow(event) || this.isEventRecent(event);
    },
    isEventUpcomingNowOrRecent(event) {
      return this.isEventUpcoming(event) || this.isEventNow(event) || this.isEventRecent(event);
    },
    isEventPendingNotEnoughAttendees(event) {
      let eventAttendeesMissingForMinAttendeesRequired = this.eventAttendeesMissingForMinAttendeesRequired(event);
      if (eventAttendeesMissingForMinAttendeesRequired !== undefined) {
        return eventAttendeesMissingForMinAttendeesRequired > 0;
      }
    },
    isEventClosedFullAttendees(event) {
      let eventAttendeesRemainingForMaxAttendeesAllowed = this.eventAttendeesRemainingForMaxAttendeesAllowed(event);
      if (eventAttendeesRemainingForMaxAttendeesAllowed !== undefined) {
        return eventAttendeesRemainingForMaxAttendeesAllowed == 0;
      }
    },
    isEventClosedForTwoFullAttendees(event) {
      let eventAttendeesRemainingForMaxAttendeesAllowed = this.eventAttendeesRemainingForMaxAttendeesAllowed(event);
      if (eventAttendeesRemainingForMaxAttendeesAllowed !== undefined) {
        return eventAttendeesRemainingForMaxAttendeesAllowed <= 1;
      }
    },
    eventAttendeesMissingForMinAttendeesRequired(event) {
      if (event.settings && event.settings.minAttendeesRequired > 0) {
        let attendingCount = this.eventInvitationAttendanceCount(event, 1) + this.eventInvitationAttendanceCount(event, 2) * 2;
        return Math.max(0, event.settings.minAttendeesRequired - attendingCount);
      }
    },
    eventAttendeesRemainingForMaxAttendeesAllowed(event) {
      if (event.settings && event.settings.maxAttendeesAllowed > 0 && event.settings.maxAttendeesAllowed < event.invitations.length) {
        let attendingCount = this.eventInvitationAttendanceCount(event, 1) + this.eventInvitationAttendanceCount(event, 2) * 2;
        return Math.max(0, event.settings.maxAttendeesAllowed - attendingCount);
      }
    },
    eventInvitationAttendanceCount(event, attendanceStatus) {
      let attendanceStatuses = event.invitations.map(invitation => invitation.attendanceStatus);
      return attendanceStatuses.reduce((count, as) => as === attendanceStatus ? count + 1 : count, 0);
    },
    eventDateTimeStatus(event) {
      if (event.dateTime) {
        let now = new Date();
        let eventDate = event.dateTime.toDate();

        if (now < eventDate) {
          return this.$DateTimeStatus.upcoming;
        }
        else if (event.durationInMinutes && (now < moment(eventDate).add(event.durationInMinutes, "minutes").toDate())) {
          return this.$DateTimeStatus.now;
        }
        else if (now < moment(eventDate).add(globals.eventRecentPeriodInHours, "hours").toDate()) {
          return this.$DateTimeStatus.recent;
        }
        else if (now >= moment(eventDate).add(globals.eventRecentPeriodInHours, "hours").toDate()) {
          return this.$DateTimeStatus.past;
        }
        else {
          return this.$DateTimeStatus.unknown;
        }
      }
    },
    eventCalloutContainerStyle(event) {
      if (this.isEventCanceled(event)) {
        return "calloutContainer_canceled";
      }
      else {
        return this.isEventPendingNotEnoughAttendees(event) ? "calloutContainer_pending" : "calloutContainer_on";
      }
    },
    eventCalloutText(event, abbreviated) {
      if (this.isEventCanceled(event)) {
        return "Canceled";
      }
      else {
        let calloutFragments = [];
        let eventDate = event.dateTime.toDate();

        if (this.isEventNow(event)) {
          calloutFragments.push("Now");
        }
        else if (this.isEventUpcoming(event)) {
          let distanceInMinutes = Math.round(moment.duration(moment(eventDate).diff(moment())).asMinutes());
          if (distanceInMinutes < 60) {
            calloutFragments.push(abbreviated ? `In ${distanceInMinutes} Minutes` : `Coming Up In ${distanceInMinutes} Minutes`);
          }
        }

        let eventAttendeesMissingForMinAttendeesRequired = this.eventAttendeesMissingForMinAttendeesRequired(event);
        if (eventAttendeesMissingForMinAttendeesRequired !== undefined && this.isEventPendingNotEnoughAttendees(event)) {
          if (!abbreviated) {
            calloutFragments.push(this.isEventUpcomingOrNow(event) ? `Minimum of ${event.settings.minAttendeesRequired}, Still Need ${eventAttendeesMissingForMinAttendeesRequired}` : `Minimum of ${event.settings.minAttendeesRequired}, Missed ${eventAttendeesMissingForMinAttendeesRequired}`);
          }
          else {
            calloutFragments.push(this.isEventUpcomingOrNow(event) ? `Need ${eventAttendeesMissingForMinAttendeesRequired}` : `Missed ${eventAttendeesMissingForMinAttendeesRequired}`);
          }
        }

        let eventAttendeesRemainingForMaxAttendeesAllowed = this.eventAttendeesRemainingForMaxAttendeesAllowed(event);
        if (eventAttendeesRemainingForMaxAttendeesAllowed !== undefined && this.isEventUpcomingOrNow(event)) {
          if (!this.isEventClosedFullAttendees(event)) {
            if (!abbreviated) {
              calloutFragments.push(`Maximum of ${event.settings.maxAttendeesAllowed}, Only ${eventAttendeesRemainingForMaxAttendeesAllowed} Left`);
            }
            else {
              calloutFragments.push(`${eventAttendeesRemainingForMaxAttendeesAllowed} Left`);
            }
          }
          else {
            if (!abbreviated) {
              calloutFragments.push(`Maximum of ${event.settings.maxAttendeesAllowed}, Full`);
            }
            else {
              calloutFragments.push("Full");
            }

          }
        }

        if (calloutFragments.length > 0) {
          return calloutFragments.join(abbreviated ? " • " : "\n");
        }
        else {
          return null;
        }
      }
    },
    formattedDateTimeString(date, eventLocation, appUserTimeZone) {
      if (eventLocation && eventLocation.timeZoneIdentifier && (!appUserTimeZone || eventLocation.timeZoneIdentifier != appUserTimeZone)) {
        // The event has a time zone ID and it's different than the user's, so use it for the date formatter and show the time zone
        return momentTimeZone(date).tz(eventLocation.timeZoneIdentifier).format('MMMM D, h:mma z');
      }
      else if (appUserTimeZone) {
        // The user has a time zone ID, so use it for the date formatter but don't show the time zone
        return momentTimeZone(date).tz(appUserTimeZone).format('MMMM D, h:mma');
      }
      else {
        // No time zone at all, so just format the date without it
        return momentTimeZone(date).format('MMMM D, h:mma');
      }
    },
    googleWeatherSymbolForSfSymbol(sfSymbol) {
      // TODO: Finish translating weather symbols below
      switch (sfSymbol) {
        case "sun.min":
          return "wb_sunny";
          break;  
        case "sun.max":
          return "sunny";
          break;
        case "cloud":
          return "cloud";
        case "cloud.sun":
          return "partly_cloudy_day";
          break;
        case "cloud.drizzle":
        case "cloud.rain":
        case "cloud.heavyrain":
        case "cloud.sun.rain":
        case "cloud.moon.rain":
          return "rainy";
          break;
        case "cloud.sun.bolt":
        case "cloud.bolt.rain":
        case "cloud.moon.bolt":
          return "thunderstorm";
          break;
        case "snowflake":
        case "cloud.snow":
        case "cloud.sleet":
        case "wind.snow":
          return "weather_snowy";
          break;
        case "cloud.fog":
          return "foggy";
          break;
        case "wind":
          return "air";
          break;
        case "moon":
        case "moon.stars":
          return "clear_night";
          break;
        default:
          return "";
      }
    }
  }
})

// handle page reloads
let app
fb.auth.onAuthStateChanged(user => {
    if (!app) {
        app = new Vue({
            el: '#app',
            router,
            store,
            render: h => h(App)
        })
    }
})



// WEBPACK FOOTER //
// ./src/main.js